





































































































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
	import SellerDetailBase from "./SellerDetailBase";

	@Component
	export default class SellerDetail extends SellerDetailBase {

	 	 	
		created() {
			this.returnRoute = "SellerList";
            super.initializeRights('COR_Seller_Update', 'COR_Seller_Update', 'COR_Seller_Update', 'COR_Seller_Update');
			super.setMainDescription('seller.new', 'seller.detail');
            this.mainDataChanged = false;
            this.createdBase();
		}

        preventRefresh(event: any) {
            if (this.$store.state.askBeforeCancelEditing === true && this.formIsInEditMode && this.dataWasChanged()) {
                event.preventDefault(); event.returnValue = "";
            }
		}

        beforeMount() {
            window.addEventListener("beforeunload", this.preventRefresh);
        }

        beforeDestroy() {
            window.removeEventListener("beforeunload", this.preventRefresh);
            this.$store.commit("formIsInEditMode", false);
            this.$store.commit("mainDataChanged", false);
        }

		mounted() {
			super.mounted();
		};

		validate() {
			return this.validateBase();
		}

		isCorrectName(value: any) {
			this.isCorrectNameBase(value);
		}
		isCorrectDate(value: any) {
			this.isCorrectDateBase(value);
		}

		isCorrectMinDate(value: any) {
			this.isCorrectMinDateBase(value);
		}

		isCorrectMaxDate(value: any) {
			this.isCorrectMaxDateBase(value);
        }
        isCorrectIc(value: any) {
            this.isCorrectIcBase(value);
        }
        isCorrectDic(value: any) {
            this.isCorrectDicBase(value);
        }

        isCorrectStreet(value: any) {
            this.isCorrectStreetBase(value);
        }

        isCorrectCity(value: any) {
            this.isCorrectCityBase(value);
        }

        isCorrectDistinct(value: any) {
            this.isCorrectDistinctBase(value);
        }

        isCorrectPostalCode(value: any) {
            this.isCorrectPostalCodeBase(value);
        }
	}
